import { Component, HostBinding } from '@angular/core';

@Component({
  selector: 'suka-card-section',
  template: `
    <ng-content></ng-content>
  `,
})
// tslint:disable-next-line: component-class-suffix
export class CardSection {
  @HostBinding('class.card-section') cardSectionClass = true;
}
